import React from 'react';
import {
  FiFilter,
  FiUsers,
  FiClock,
  FiLink,
  FiGitBranch,
  FiFile,
  FiRepeat,
  FiShare2,
  FiGrid,
  FiDatabase,
} from 'react-icons/fi';
import ProductDocumentPricing from '../ProductDocumentPricing/ProductDocumentPricing';
import './ProductDocumentContent.css';

const ProductDocumentContent = () => {
  const sixBoxes = [
    { title: 'Cloud Storage', description: 'Store your documents and access them from anywhere – secure and safe.' },
    { title: 'Collaborate', description: 'Share documents with your departments, branch or select individuals. Update them in one place.' },
    { title: 'Version Tracking', description: 'Automated version tracking of the documents with access to previous versions and update logs.' },
    { title: 'Reminders', description: 'As per document expiry, receive reminders for renewal. Link this to Tasks for informing respective team members.' },
    { title: 'Easy Sharing', description: 'Share documents with your colleagues or external members with one click process.' },
    { title: 'Unlimited Storage', description: 'Get unlimited storage space for your organization with unlimited users.' },
  ];

  const features = [
    { icon: <FiFilter />, text: 'Customized classification' },
    { icon: <FiUsers />, text: 'Branch/Department wise access' },
    { icon: <FiClock />, text: 'Reminders based on Expiry' },
    { icon: <FiLink />, text: 'Link to Staff and Vehicle masters' },
    { icon: <FiGitBranch />, text: 'Automatic Version History' },
    { icon: <FiFile />, text: 'Large size document support' },
    { icon: <FiRepeat />, text: 'No expiry of documents' },
    { icon: <FiShare2 />, text: 'Easy sharing options' },
    { icon: <FiGrid />, text: 'Customized views' },
    { icon: <FiDatabase />, text: 'Unlimited storage space' },
  ];

  return (
    <>
      {/* Six boxes from home page */}
      <section className="product-document-six-boxes">
        <div className="container">
          <div className="features-grid">
            {sixBoxes.map((box, index) => (
              <div key={index} className="feature-card">
                <h3>{box.title}</h3>
                <p>{box.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features list */}
      <section className="product-document-features">
        <div className="container">
          <h2 className="product-document-features-title">Features</h2>
          <ul className="product-document-features-list">
            {features.map((feature, index) => (
              <li key={index}>
                <span className="product-document-feature-icon">{feature.icon}</span>
                <span className='text-muted'>{feature.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Prices - Subscription details without Select, with Subscribe Now */}
      <ProductDocumentPricing />
    </>
  );
};

export default ProductDocumentContent;
